import suiteService from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';
import eventoServices from 'qreventos-suite/eventos';
import generalService from 'qreventos-suite/generales';
import empresaService from 'qreventos-suite/empresas';

class SuiteConfig {
  token: string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4UGtXZ05VMWYzclVtbXdBYU1sclNFWT0=';
  clientId: string = 'ad2d0388-6511-4828-9ac6-8c0f8b0f6ade-INVI';

  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;

    invitacionService.clientId = this.clientId;
    invitacionService.token = this.token;

    eventoServices.clientId = this.clientId;
    eventoServices.token = this.token;

    generalService.clientId = this.clientId;
    generalService.token = this.token;

    empresaService.clientId = this.clientId;
    empresaService.token = this.token;


  }
}

export default new SuiteConfig();